import { Reducer, useReducer } from 'react';

const forceRefreshReducer: Reducer<unknown, void> = () => ({});

/**
 * Call the return function to queue a new render
 */
export const useForceRefresh = () => useReducer(forceRefreshReducer, {})[1];
